<template>
    <v-navigation-drawer
        app
        light
        floating
        fixed
        :color="$vuetify.theme.dark === false ? 'white' : '#0F1D25'"
        :mini-variant="miniSidebar"
        :expand-on-hover="miniSidebar"
        v-model="drawer"
        mobile-break-point="1024"
        v-on:input="isNavShow"
        class="elevation-5 d-print-none"
        style="z-index: 200"
    >
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="headline font-weight-light">
                    <span
                        :style="
                            $vuetify.theme.dark === false
                                ? 'font-size:30px; font-family: Impact, Charcoal, sans-serif'
                                : 'font-size:30px; font-family: Impact, Charcoal, sans-serif; color:#00ff83'
                        "
                        >Hybrid Pro</span
                    >
                    <span class="ml-1" style="font-size: 11px; color: #718696">
                        V
                        <span
                            :style="
                                $vuetify.theme.dark === true
                                    ? 'color:#7a0020'
                                    : ''
                            "
                            >1.8.8</span
                        >
                    </span>
                </v-list-item-title>
                <v-list-item-subtitle class="font-weight-light mar-t-10">
                    <v-row>
                        <v-col cols="3">
                            <v-avatar>
                                <img
                                    :src="url_pic + member.img"
                                    :alt="member.name"
                                />
                            </v-avatar>
                        </v-col>
                        <v-col
                            cols="9"
                            style="margin-top: -6px; padding-right: 0px"
                        >
                            <v-row>
                                <v-col cols="12">
                                    <b
                                        :style="
                                            $vuetify.theme.dark === false
                                                ? ''
                                                : 'color:#FFC107'
                                        "
                                        >{{ member.name }}</b
                                    >
                                    <br />
                                    <span style="color: #718696">
                                        {{ member.team }}
                                    </span>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="mar-t-15">
                            <p>
                                <v-icon
                                    class="icon-fix cur-p"
                                    small
                                    v-if="member.time_in != ''"
                                    color="teal"
                                    @click="get_page_timeatt()"
                                    >mdi-alarm-check</v-icon
                                >
                                <span
                                    class="teal--text cur-p"
                                    @click="get_page_timeatt()"
                                    v-if="member.time_in != ''"
                                >
                                    <b class="m-1">
                                        {{ member.time_in }}
                                    </b>
                                </span>
                                <v-icon
                                    class="icon-fix cur-p"
                                    small
                                    v-if="member.time_in == ''"
                                    color="red"
                                    @click="get_page_timeatt()"
                                    >mdi-alarm-off</v-icon
                                >
                                <span
                                    class="red--text cur-p"
                                    @click="get_page_timeatt()"
                                    v-if="member.time_in == ''"
                                >
                                    <b class="ml-1">ไม่ได้ลงเวลาเข้างาน</b>
                                </span>
                            </p>

                            <!-- <br v-if="member.time_in != ''" /> -->
                            <p style="margin-top: -12px">
                                <v-icon
                                    class="icon-fix"
                                    style="color: #546e7a"
                                    small
                                    v-if="
                                        member.device == 'pc' &&
                                            member.time_in != ''
                                    "
                                    >mdi-desktop-mac</v-icon
                                >
                                <v-icon
                                    class="icon-fix"
                                    style="color: #546e7a"
                                    small
                                    v-if="
                                        member.device == 'mobile' &&
                                            member.time_in != ''
                                    "
                                    >mdi-cellphone-iphone</v-icon
                                >
                                <span
                                    style="color: #546e7a"
                                    v-if="member.time_in != ''"
                                    class="ml-1"
                                >
                                    {{ member.branch }}
                                </span>
                            </p>
                        </v-col>
                    </v-row>

                    <!-- {{ member.team }} -->
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-divider class="mar-t-10"></v-divider>
        <v-list dense nav v-for="item in get_data" :key="item.menu_id">
            <v-list-item link v-if="item.submenu == ''" :to="item.menu_path">
                <v-list-item-icon>
                    <v-icon>{{ item.menu_icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title
                        @click="func_chk_tk()"
                        :class="
                            $vuetify.theme.dark === false
                                ? 'font-regular'
                                : 'font-regular white--text'
                        "
                    >
                        {{ item.menu_name }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-group
                v-else
                :prepend-icon="item.menu_icon"
                no-action
                :color="
                    $vuetify.theme.dark === false
                        ? 'teal accent-4'
                        : 'cyan accent-2'
                "
            >
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title
                            @click="func_chk_tk()"
                            :class="
                                $vuetify.theme.dark === false
                                    ? 'font-regular'
                                    : 'font-regular white--text'
                            "
                            v-text="item.menu_name"
                        ></v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item
                    link
                    v-for="subItem in item.submenu"
                    :key="subItem.submenu_id"
                    :to="subItem.path"
                >
                    <v-list-item-content>
                        <v-list-item-title
                            @click="func_chk_tk()"
                            :class="
                                $vuetify.theme.dark === false
                                    ? 'font-regular'
                                    : 'font-regular white--text'
                            "
                            v-text="subItem.submenu_name"
                        ></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import firebaseApp from "../firebase"
const url = `${process.env.VUE_APP_ROOT_API}/api/getsidemenu/`
const urlx = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    computed: {
        ...mapState(["miniSidebar"]),
        ...mapState(["isLoading"]),
        ...mapState(["chk_token"]),
        drawer() {
            // console.log(this.$store.state.drawer)
            return this.$store.state.drawer
        },
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_menu()
    },
    methods: {
        ...mapMutations(["mutateMiniSidebar"]),
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutateToken"]),
        isNavShow(el) {
            const isMobile = this.$vuetify.breakpoint.smAndDown
            const obj = {
                isMobile: isMobile,
                navShow: el,
            }

            this.mutateMiniSidebar(obj)
        },
        async get_menu() {
            this.mutateIsLoading()
            await axios.get(url, this.tk).then((response) => {
                this.mutateIsLoading()
                if (response.data.status == "token_expired") {
                    this.logout()
                } else {
                    this.get_data = response.data
                    this.get_emp_id()
                }
            })
        },
        func_chk_tk() {
            let date_a = new Date()
            let date = new Date(localStorage.storagetime)
            date.setHours(date.getHours() + 2)

            let seconds = (date_a - date) / 1000
            if (seconds > 0) {
                this.mutateToken()
            } else {
                date_a.setHours(date_a.getHours() + 2)
                localStorage.setItem("storagetime", date_a)
            }
            // console.log(localStorage.storagetime)
        },
        async get_emp_id() {
            await axios
                .get(urlx + "account-detail", this.tk)
                .then((response) => {
                    this.emp_id = response.data.emp_id
                    this.member.time_in = response.data.time_in
                    this.member.device = response.data.device
                    this.member.branch = response.data.branch
                    this.get_lan_lng()
                })
        },
        get_lan_lng() {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.gps.lat = position.coords.latitude
                    this.gps.lng = position.coords.longitude

                    this.update_gps_sv()
                },
                (error) => {
                    console.log(error.message)
                }
            )
        },
        async update_gps_sv() {
            await axios
                .post(urlx + "engineer/save-location", this.gps, this.tk)
                .then((response) => {
                    this.update_gps()
                })
        },
        update_gps() {
            let database = firebaseApp.database()
            let userID = this.emp_id
            let ref = firebaseApp.database().ref("gpstracking/")
            let name = this.role_name

            let postData = {
                lat: this.gps.lat,
                lng: this.gps.lng,
                name: this.fullname,
                role_type: this.role_type,
                lastUpd: new Date().toLocaleString(),
            }
            let updates = {}
            updates["/gpstracking/" + userID + "/"] = postData

            return firebaseApp
                .database()
                .ref()
                .update(updates)
        },
        get_page_timeatt() {
            if (
                this.team_name != "ONSITE" ||
                (this.team_name == "ONSITE" &&
                    (this.role_name == "WFH" || this.role_name == "TL"))
            ) {
                let routeData = this.$router.resolve({
                    path: "/Timeatt",
                    query: { q: this.emp_id },
                })
                // let url_map = "/Timeatt"
                window.open(routeData.href, "_blank")
            }
        },

        logout() {
            localStorage.removeItem("storagetime")
            localStorage.removeItem("fullname")
            localStorage.removeItem("token")
            localStorage.removeItem("team_name")
            localStorage.removeItem("emp_img")
            localStorage.removeItem("themes")
            localStorage.removeItem("chk_newuser")
            localStorage.removeItem("role_type")
            localStorage.removeItem("travel_mode")

            this.mutateToken()
        },
    },
    data() {
        return {
            tk: null,
            get_data: [],
            member: {
                name: localStorage.fullname,
                team: localStorage.team_name,
                img: localStorage.emp_img,
                device: "",
                branch: "",
                time_in: "",
            },
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/profile_img/`,
            role_name: localStorage.role_name,
            team_name: localStorage.team_name,
            role_type: localStorage.role_type,
            fullname: localStorage.fullname,
            gps: {
                lat: "",
                lng: "",
            },
            emp_id: "",
        }
    },
}
</script>
<style scoped>
.icon-fix {
    margin-top: -2px !important;
}
</style>
